module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.styles.tableContainerStyle)
  }, [_c('table', {
    staticClass: "headers",
    style: (_vm.styles.headerTableStyle)
  }, [_c('tr', {
    style: (_vm.styles.trStyle)
  }, _vm._l((_vm.headers), function(headerText) {
    return _c('th', {
      style: (_vm.styles.thStyle)
    }, [_vm._v("\n        " + _vm._s(headerText.value) + "\n      ")])
  }))]), _vm._v(" "), _c('table', {
    staticClass: "data",
    style: (_vm.styles.headerTableStyle)
  }, _vm._l((_vm.dataAsComputed), function(row, rowKey) {
    return _c('tr', {
      style: (_vm.styles.trStyle)
    }, _vm._l((row), function(field, fieldKey) {
      return _c('td', {
        staticClass: "row",
        style: (_vm.styles.tdStyle)
      }, [(field.editable) ? _c('div', [(field.edit) ? _c('div', [_c('input', {
        directives: [{
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: (_vm.resetToFalse(rowKey, fieldKey)),
          expression: "resetToFalse(rowKey, fieldKey)"
        }],
        style: (_vm.styles.editableLabel),
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (_vm.dataAsComputed[rowKey][fieldKey]).value
        },
        on: {
          "keyup": function($event) {
            _vm.updateData($event, rowKey, fieldKey)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "fa fa-check",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e(), _vm._v(" "), (!field.edit) ? _c('div', {
        style: (_vm.styles.editableLabel)
      }, [_vm._v("\n            " + _vm._s(field.value) + "\n          ")]) : _vm._e(), _vm._v(" "), (!field.edit) ? _c('div', {
        style: (_vm.styles.editableEditBox),
        on: {
          "click": function($event) {
            _vm.editData(rowKey, fieldKey)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!field.editable) ? _c('div', [_vm._v("\n          " + _vm._s(field.value) + "\n        ")]) : _vm._e()])
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eacd53b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/flexTables/HorizontalTable.vue
// module id = 367
// module chunks = 2